import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Audit from "@/pages/Audit";
import Modules from "@/pages/Modules";
import ModuleDetail from "@/pages/ModuleDetail";
import Method from "@/pages/Method";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Team from "@/pages/Team";
import TeamSheet from "@/pages/TeamSheet";
import Paper from "@/pages/Paper";
import Pricing from "@/pages/Pricing";
import Checkout from "@/pages/Checkout";
import PaymentSuccess, { PaymentCancel } from "@/pages/Payment";
import Authorize from "@/pages/Authorize";
import Portal from "@/pages/Portal";
import { Dealers, LegalDoc, AuthorizedTest } from "@/pages/Content";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/modules" element={<Modules />} />
          <Route path="/modules/:slug" element={<ModuleDetail />} />
          <Route path="/method" element={<Method />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team/:code" element={<TeamSheet />} />
          <Route path="/paper" element={<Paper />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/authorize" element={<Authorize />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/dealers" element={<Dealers />} />
          <Route path="/terms" element={<LegalDoc />} />
          <Route path="/privacy" element={<LegalDoc />} />
          <Route path="/authorization-agreement" element={<LegalDoc />} />
          <Route path="/authorized-test" element={<AuthorizedTest />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#1A1A18", color: "#F2EDE3", border: "1px solid #8C8271", borderRadius: 0, fontFamily: "'Courier Prime', monospace", fontSize: 12, letterSpacing: "0.08em", textTransform: "uppercase" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
